import { STATE_TYPES } from '../constants'
import Vue from '@/main'

export default function getAutomationBadge(stateType) {
  switch (stateType) {
    case STATE_TYPES.ENABLED:
      return {
        translation: Vue.$t('automation.state.active'),
        classes: ['text-success bg-green-100'],
        type: STATE_TYPES.ENABLED,
      }
    case STATE_TYPES.DRAFT:
      return {
        translation: Vue.$t('automation.state.draft'),
        classes: ['bg-gray-200'],
        type: STATE_TYPES.DRAFT,
      }
    case STATE_TYPES.DISABLED:
      return {
        translation: Vue.$t('automation.state.inactive'),
        classes: ['bg-yellow-100 text-yellow-500'],
        type: STATE_TYPES.DISABLED,
      }
    case STATE_TYPES.PENDING_CAMPAIGN_CREATION:
      return {
        translation: Vue.$t('automation.state.pendingCampaingCreation'),
        classes: ['bg-cyan-100 text-blue'],
        type: STATE_TYPES.PENDING_CAMPAIGN_CREATION,
      }
    case STATE_TYPES.STOPPED:
      return {
        translation: Vue.$t('automation.state.stopped'),
        classes: ['bg-red-100 text-error'],
        type: STATE_TYPES.STOPPED,
      }
    case STATE_TYPES.INVALID:
      return {
        translation: Vue.$t('automation.state.invalid'),
        classes: ['bg-red-100 text-error'],
        type: STATE_TYPES.INVALID,
      }
    default:
      return {}
  }
}
